export default "<div style='width: 90vw; height: 93vh;'>\r\n</div>\r\n"